<lib-auth-container
  headerTXT="{{ 'auth.forgot.view_title' | translate }}"
  btnLabel="{{ 'auth.forgot.button_action' | translate }}"
  (btnClick)="forgotPassword(mailControl.value + '')"
  [(loading)]="isLoading"
  [disabled]="mailControl.invalid"
>
  <form #initProcess>
    <label for="username" class="font-normal px-1 !text-gray-500" hlmLabel>{{
      'auth.forgot.view_email_label' | translate
    }}</label>
    <input
      id="username"
      class="w-full !py-2"
      hlmInput
      [formControl]="mailControl"
      required
      [placeholder]="'auth.forgot.view_email_placeholder' | translate"
    />
    @if ( hasError("required") ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.login.error_required_username' | translate }}
    </p>
    } @if ( hasError("email") ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.forgot.error_email_invalid' | translate }}
    </p>
    }
  </form>
</lib-auth-container>
